import IconBase from "react-icon-base";
import React from "react";

export default function Icon(props) {
  return (
    <IconBase
      {...props}
      viewBox={"0 0 24 24"}
      dangerouslySetInnerHTML={{
        __html: `<svg id="Icons" enable-background="new 0 0 128 128" height="100%" viewBox="0 0 128 128" width="100%" xmlns="http://www.w3.org/2000/svg"><path id="Check_Mark" d="m 64 128 z m 0 -120 z m -9.172 78.828 l 40 -40 c 1.563 -1.563 1.563 -4.094 0 -5.656 s -4.094 -1.563 -5.656 0 l -37.172 37.172 l -13.172 -13.172 c -1.563 -1.563 -4.094 -1.563 -5.656 0 s -1.563 4.094 0 5.656 l 16 16 c 0.781 0.781 1.805 1.172 2.828 1.172 s 2.047 -0.391 2.828 -1.172 z"/></svg>`,
      }}
    />
  );
}
